import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Lara from '@primeuix/themes/lara';
import BomEditor from 'components/bom/BomEditor.vue';
import bsTooltip from 'directives/bsTooltip';
import { vueDebounce } from 'vue-debounce';
import { i18n } from 'locales';
import ProjectCheckoutButton from 'components/project/ProjectCheckoutButton.vue';
import { createPinia } from 'pinia';
import { useBomStore, useAssignStore } from 'store/bom';

const getEndpoints = () => {
  const mountElement = '#vue-bom-editor';
  const bomEditor = document.querySelector(mountElement);
  if (bomEditor === null) {
    return null;
  }

  return bomEditor.dataset;
};

const pinia = createPinia();
const app = createApp();
app.use(i18n);
app.use(pinia);
app.use(PrimeVue, {
  theme: {
    preset: Lara,
    options: {
      darkModeSelector: false,
    },
  },
});
app.component(BomEditor.name, BomEditor);
app.directive('debounce', vueDebounce({
  listenTo: 'input',
  defaultTime: '500ms',
}));
app.directive('bs-tooltip', bsTooltip);

const endpoints = getEndpoints();
const bomStore = useBomStore();
bomStore.initialize(endpoints);
const assignStore = useAssignStore();
assignStore.initialize(endpoints);

app.mount('#vue-bom-editor');

const app2 = createApp();
app2.component(ProjectCheckoutButton.name, ProjectCheckoutButton);
app2.use(i18n);
app2.mount('#vue-project-checkout-button');
